import React from "react";
import { Input, Button } from "reactstrap";

export const TrailRequestcolumns = (editRow: number | null, editedValues: any, handleDoubleClick: any, handleChange: any, handleSubmit: any) => [
    {
        name: "Name",
        selector: (row: any) => row.first_name + (row.last_name ? " " + row.last_name : ""),
        sortable: true,
        cell: (row: any) => (
            editRow === row.id ? (
                <Input
                    type="text"
                    name="first_name"
                    value={editedValues.first_name || ""}
                    onChange={(e) => handleChange(row.id, e)}
                />
            ) : (
                <span onDoubleClick={() => handleDoubleClick(row)}>
                    {row.first_name + (row.last_name ? " " + row.last_name : "")}
                </span>
            )
        )
    },
    {
        name: "Email",
        selector: (row: any) => row.email,
        sortable: true,
        cell: (row: any) => (
            editRow === row.id ? (
                <Input
                    type="text"
                    name="email"
                    value={editedValues.email || ""}
                    onChange={(e) => handleChange(row.id, e)}
                />
            ) : (
                <span onDoubleClick={() => handleDoubleClick(row)}>
                    {row.email}
                </span>
            )
        )
    },
    {
        name: "Company Name",
        selector: (row: any) => row.company_name,
        sortable: true,
        cell: (row: any) => (
            editRow === row.id ? (
                <Input
                    type="text"
                    name="company_name"
                    value={editedValues.company_name || ""}
                    onChange={(e) => handleChange(row.id, e)}
                />
            ) : (
                <span onDoubleClick={() => handleDoubleClick(row)}>
                    {row.company_name}
                </span>
            )
        )
    },
    {
        name: "Action",
        cell: (row: any) => (
            editRow === row.id ? (
                <Button color="success" onClick={() => handleSubmit(row.id)}>Save</Button>
            ) : (
                <Button color="primary" onClick={() => handleDoubleClick(row)}>Edit</Button>
            )
        )
    }
];
